<template>
  <div>
    <div class="table-actions">
      <Layout>
        <Column size="3">
          <div
            class="filter__table"
            v-if="columns.filter((x) => x.searchable).length !== 0 && data.length"
          >
            <i class="mdi mdi-magnify"></i>
            <input :placeholder="customPlaceholder" type="text" v-model="filter" />
          </div>
        </Column>
        <Column size="4">
          <slot :total="assigned" name="readInfo" />
        </Column>
        <Column align="right" size="5" v-if="showActions">
          <transition name="fade">
            <div
              class="selector-actions"
              v-if="!notifyOnlyIfChanged || (notifyOnlyIfChanged && dataChanged)"
            >
              <!--countSelected > 0-->
              <span class="selector-count">
                {{ countSelected }}
                {{ actionSelectedWord + (countSelected !== 1 ? 's' : '') }}
                seleccionado{{ countSelected !== 1 ? 's' : '' }}
              </span>
              <Button :icon="actionIcon" @click="actionPressed" class="selector-action">
                {{ actionText }}
              </Button>
            </div>
          </transition>
        </Column>
      </Layout>
    </div>
    <div class="table">
      <table class="pw-selector-datagrid">
        <thead class="pw-selector-datagrid__head">
          <tr>
            <th style="width: 28px; text-align: center">
              <CheckBox
                @input="onSelect"
                class="custom-checkbox-grid"
                ref="check"
                style="top: -4px"
                v-model="selected"
              />
            </th>
            <th
              :key="index"
              v-bind:style="{
                width:
                  widthLastRows && index !== 0
                    ? typeof widthLastRows === 'number'
                      ? widthLastRows + 'px'
                      : widthLastRows
                    : 'auto',
              }"
              v-for="(column, index) in columns"
            >
              <span v-html="column.title" />
            </th>
          </tr>
        </thead>

        <template v-for="(item, index) in filteredData">
          <GridSelectorItem
            :columns="columns"
            :expand="expandAll"
            :item="item"
            :key="index"
            :selector="selectorsControl[index]"
            :widthLastRows="widthLastRows"
            @assigned="setAssigned"
            @checkItem="checkRoot()"
            @uncheckItem="uncheckRoot()"
            ref="selectorItem"
          />
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import CheckBox from './CheckBox.vue';
import GridSelectorItem from './GridSelectorItem.vue';
import Column from './Column.vue';
import Button from './Button.vue';

export default {
  name: 'GridSelector',
  components: { Button, Column, CheckBox, GridSelectorItem },
  props: {
    customPlaceholder: {
      type: String,
      default: 'Buscar',
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    widthLastRows: {
      type: [Number, String],
      default: null,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    notifyOnlyIfChanged: {
      type: Boolean,
      default: true,
    },
    actionSelectedWord: {
      type: String,
      default: 'Registro',
    },
    actionIcon: {
      type: String,
      default: '',
    },
    actionText: {
      type: String,
      default: 'Asignar',
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
    customKey: {
      type: String,
      default: 'id',
    },
  },
  data() {
    return {
      filter: '',
      assigned: 0,
      selected: false,
      selectorsControl: this.getChildren(this.data),
      initialSelectors: this.getChildren(this.data),
    };
  },
  methods: {
    resetInitialSelectors(newData) {
      this.initialSelectors = this.getChildren(newData);
      this.updateView();
    },
    actionPressed() {
      this.$emit('getSelectors', this.selectorsControl);
      this.$emit('getValues', this.getValuesArray(this.selectorsControl));
    },
    onSelect(state) {
      if (this.$refs.selectorItem) {
        this.$refs.selectorItem[0].setChildren(this.$refs, state);
        this.$refs.selectorItem[0].setSelectors(this.selectorsControl, state);
      }
    },
    getChildren(data) {
      return data.map((child) => {
        const selected = child.selected || false;

        if (child.children)
          return {
            id: child.id,
            partial: false,
            selected: selected,
            disabled: child.disabled,
            dependentOn: child.dependentOn,
            children: this.getChildren(child.children),
          };
        return {
          id: child.id,
          partial: false,
          selected: selected,
          disabled: child.disabled,
          dependentOn: child.dependentOn,
        };
      });
    },
    checkRoot() {
      this.selected = true;

      const checkedAll = this.selectorsControl.every(
        (selector) => selector.selected || selector.disabled
      );
      this.setPartialCheck(!checkedAll);

      if (checkedAll) {
        const partialChecked = this.selectorsControl.some((child) => child.partial);
        this.setPartialCheck(partialChecked);
      }
    },
    uncheckRoot() {
      const uncheckedAll = this.selectorsControl.every((selector) => !selector.selected);

      this.selected = !uncheckedAll;
      this.setPartialCheck(!uncheckedAll);
    },
    setPartialCheck(value) {
      this.$refs.check.setPartialCheck(value);
    },
    setAssigned(counted) {
      this.assigned += counted;
      // console.log('setAssigned!!!!!')
      // console.log(this.selectorsControl)
      // console.log(this.initialSelectors)
    },
    selectedChildren(selectors) {
      let total = 0;
      selectors.forEach((selector) => {
        total += selector.selected && !selector.children ? 1 : 0;
        if (selector.children) total += this.selectedChildren(selector.children);
      });
      return total;
    },
    getValuesArray(array) {
      return array
        .map((element) => {
          if (element.children) return this.getValuesArray(element.children);

          if (element[this.customKey] && !element.disabled && element.selected) {
            return element[this.customKey];
          }
          return null;
        })
        .flat()
        .filter((v) => v);
    },
    updateView() {
      if (this.$refs.selectorItem) {
        this.$refs.selectorItem.forEach((row) => {
          row.$forceUpdate();
          this.updateChildrenViews(row);
        });
      }
    },
    updateChildrenViews(row) {
      if (row.$refs.selectorItem) {
        if (Array.isArray(row.$refs.selectorItem)) {
          row.$refs.selectorItem.forEach((r) => {
            r.$forceUpdate();
            this.updateChildrenViews(r);
          });
        } else {
          row.$refs.selectorItem.$forceUpdate();
        }
      }
    },
    filterInChildren(row, field) {
      if (row.children) {
        for (let i = 0; i < row.children.length; i++) {
          const child = row.children[i];
          const result =
            String(child[field]).toLowerCase().includes(this.filter.toLowerCase()) ||
            this.filterInChildren(child, field);

          if (result) {
            return result;
          }
        }
      }
      return false;
    },
  },
  watch: {
    filteredData(newData) {
      this.selectorsControl = this.getChildren(newData);
      this.initialSelectors = this.getChildren(newData);
    },
  },
  computed: {
    countSelected() {
      return this.selectedChildren(this.selectorsControl);
    },
    dataChanged() {
      const currents = this.getValuesArray(this.selectorsControl);
      const changes = this.getValuesArray(this.initialSelectors);

      if (currents.length !== changes.length) return true;
      for (let i = 0; i < currents.length; ++i) {
        if (currents[i] !== changes[i]) return true;
      }
      return false;
    },
    filteredData() {
      const columnsWithFilter = [...this.columns.filter((y) => y.searchable)]
        .map((y) => y.field)
        .filter((y) => y);

      const result = this.data.filter((x) => {
        if (this.filter === '') {
          return true;
        }

        const value =
          columnsWithFilter
            .map((y) => {
              return (
                String(x[y]).toLowerCase().includes(this.filter.toLowerCase()) ||
                this.filterInChildren(x, y)
              );
            })
            .filter((y) => y).length !== 0;
        return value;
      });
      // console.log(result);

      return result;
    },
  },
};
</script>

<style lang="scss">
.filter__table {
  background-color: #fff;
  border: 1px solid #d5dbf3;
  border-radius: 3px;
  display: flex;
  padding: 4px;

  i {
    color: #89959e;
    margin-right: 8px;
  }

  input {
    background-color: transparent;
    border: 0;
    flex: auto;
    outline: none;
  }
}

/*.selector-actions {*/
/*  position: relative;*/
/*}*/

.selector-count {
  color: #5186ff;
  font-size: 14px;
  margin-right: 8px;
}

.selector-action {
  color: #294381 !important;
  border-color: transparent !important;
  background-color: transparent !important;
  font-size: 14px !important;
  padding: 8px 8px;
}

.pw-selector-datagrid {
  margin-top: 10px;
  width: 100%;
  text-align: left;
  border-spacing: 0;
  /*table-layout: fixed;*/
  /*border-collapse: separate;*/
  padding: 0;

  &__head {
    tr {
      th:nth-child(2) {
        padding-left: 20px;
      }

      th {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }

    th {
      color: #333333;
      /*line-height: 22px;*/
      font-weight: bold;
      background-color: #fbfbfb;
      border-bottom: 1px solid #d8e3eb;
      /*padding: 8px;*/
      /*padding-left: 8px;*/
    }
  }
}
</style>
